import { Component, OnInit } from '@angular/core';
import { LicenseDataService } from '../../services/LicenseData.service';
import { AdminData } from '../../models/AdminData.model';
import { AdminUserData } from '../../models/AdminUserData.model';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { ErrorModel } from '../../../../shared/models/Error.model';
import { Router } from '@angular/router';


@Component({
  selector: 'app-dash',
  templateUrl: './dash.component.html',
  styleUrls: ['./dash.component.css']
})
export class DashComponent implements OnInit {
  stats;
  licenseUsers: AdminUserData[] = [];
  newLicenses: AdminUserData[];
  currentPage: number = 1;
  showOverlay: boolean;
  admins: AdminData[];
  popupLoader: boolean;
  showAdminListLoader: boolean;
  item = 0;
  dashHaCount: number = 0;
  userDetailError = new ErrorModel();
  searchError = new ErrorModel();
  mainViewError = new ErrorModel();
  currentSelectedAdmin: string;


  //for search
  searchTerm: string = '';


  //for server side pagination and searching
  // CurrentPage: number = 1;

  progressDetails: any[];
  monthNames = ['', 'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  //notification just for testing

  constructor(private service: LicenseDataService, private router: Router) {

  }

  ngOnInit() {
    this.dashHaCount = 0;
    this.currentPage = 1;
    this.getDashboardData();

  }


  getDashboardData() {
    this.showOverlay = true;

    this.mainViewError.display = false;
    this.service.getDashData(1, '').subscribe((data) => {
      this.admins = data['AdminLicenseDetails'];
      this.dashHaCount = data['HaAdminCount'];
      this.stats = data['Stats'];
      this.progressDetails = data['ProductSoldData'];

      for (let val of this.progressDetails) {
        const RegCount = val.RegisteredCount;
        val.RegisteredCount = 0;
        for (let x = 1; x <= RegCount; x++) {
          setTimeout(() => {
            val.RegisteredCount = x;

          }, 1000);
        }
        val.mnth = this.monthNames[val.month];
      }
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;

    }).add(() => {
      this.showOverlay = false;
    });

  }


  onScrollGetAdmins() {
    this.showAdminListLoader = true;
    this.currentPage = this.currentPage + 1;
    this.service.getDashData(this.currentPage, this.searchTerm).subscribe(
    (data) => {
      if (data['AdminLicenseDetails'].length == 0) {
        AlertMessages.Show('Done', 'Reached End of List', AlertType.Warning);
      }
      let admins: AdminData[] = data['AdminLicenseDetails']
      // console.log(btoa("password"));
      // console.log(atob("cGFzc3dvcmQ="));
      if (admins !== undefined) {
        admins.forEach(i => {
          this.admins.push(i); 
        });
      }
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not get results', AlertType.Error);
    }
    ).add(() => {
      this.showAdminListLoader = false;
    });

  }


  searchAdmin(searchText: string) {
    this.searchTerm = searchText;
    this.showAdminListLoader = true;
    this.currentPage = 1;
    this.searchError.display = false;
    this.service.getDashData(1, searchText.trim()).subscribe(
      (data) => {
      this.admins = data['AdminLicenseDetails'];
    },
    (error) => {
      this.searchError.error = error;
      this.searchError.display = true;
    }).add(() => {
      this.showAdminListLoader = false;
    });
  }

  openDetails(adminId) {
    this.currentSelectedAdmin = adminId;
    this.popupLoader = true;
    this.userDetailError.display = false;
    this.licenseUsers = [];
    this.item = this.admins.findIndex(admin => admin.id == adminId);
    this.service.getAdminUsers(adminId).subscribe(
    (data) => {
      this.newLicenses = data as AdminUserData[];
      this.licenseUsers = this.newLicenses.filter((user) => user.adminIsDeleted == false);
    },
    (error) => {
      this.userDetailError.error = error;
      this.userDetailError.display = true;
    }).add(() => {
      this.popupLoader = false;
    });
  }


  routingDash(evt) {
    if (evt.route == 'Admin') {
      this.router.navigate(['SA/Home/admin'], { queryParams: { 'filterLicense': evt.number, 'routingPath': 'Dashboard>Admin' } });
    }

    if (evt.route == 'AllLic') {
      this.router.navigate(['SA/Home/details'], { queryParams: { 'filterLicense': evt.number, 'routingPath': 'Dashboard>License' } });
    }

    if (evt.route == 'ExpiredLic') {
      this.router.navigate(['SA/Home/details'], { queryParams: { 'filterLicense': evt.number, 'routingPath': 'Dashboard>License' } });
    }

    if (evt.route == 'BlockedLic') {
      this.router.navigate(['SA/Home/details'], { queryParams: { 'filterLicense': evt.number, 'routingPath': 'Dashboard>License' } });
    }
  }
}


